<template>

      <sc-dropdown-item
        class="card-dropdown-item"
        :disabled="this.app.status === 'UNINSTALLED'"
        @click="() => handleUninstallButton()"
      >
        <span> <sc-icon icon="times"></sc-icon> Desinstalar </span>
      </sc-dropdown-item>

</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScButton,
  ScIcon,
  ScDropdown,
  ScDropdownItem,
  ScToast,
  ScDialog,
} from "@intelipost-js/secure-components";

const { mapActions } = createNamespacedHelpers("integrations/integrationsHome");

export default {
  name: "iplink-app-card-header-menu",

  props: {
    app: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      "getAppList",
      "uninstallIntegrationAction",
      "selectAppAction"
    ]),

    handleUninstallButton() {
      return ScDialog.confirm({
        title: "Confirmação de desinstalação",
        message: `Você tem certeza que deseja desinstalar o aplicativo <b>${this.app.name}</b>?`,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        onConfirm: () =>
          this.uninstallIntegrationAction(this.app.installation_id).then(
            ({ ok, message }) => {
              if (ok) {
                this.getAppList();
                this.integrationListCache = this.app;

                return ScToast.success("Aplicativo desinstalado com sucesso");
              }
              return ScToast.open({message, duration: 20000, type: 'is-danger'});
            }
          ),
      });
    },

  },

  components: {
    ScIcon,
    ScDropdownItem,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";


</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/header-card/menu-card/uninstall-button/UninstallButton.vue?bae768ce